<template>
  <div>
    <index-form
      ref="form"
      class="mt-4"
      @save="onSaveDraft"
      @cancel="onCancel"
      @publish="onPublish"
      @update="onUpdate"
    />

    <div class="d-flex justify-content-between mb-4">
      <button class="btn btn-outline-primary" @click="$refs.form.cancel()">Cancel</button>
      <button
        class="btn btn-outline-primary"
        @click="$refs.form.save()"
      >Save Draft</button>
      <button
        class="btn btn-primary"
        @click="$refs.form.publish()"
      >Publish</button>
    </div>
    <confirm
      v-if="hasDifferentTitle"
      :title="index.draft.title"
      :old-title="index.title"
      @confirmed="confirmedPublishing"
    />
  </div>
</template>

<script>
import {Vue, Component, namespace} from 'nuxt-property-decorator'
import gateway from '@/gateway'
import { successNotification, warningNotification } from '@/notifications'
import IndexForm from './Form'
import Confirm from './Confirm.vue'

@Component({
  components: {
    IndexForm,
    Confirm,
  },
})
export default class DraftHOC extends Vue {
  @namespace('indices').Getter currentIndex

  onCancel() {
    this.$router.push('/indices')
  }

  get index() {
    return this.currentIndex
  }

  get hasDifferentTitle() {
    return this.index.title !== 'Create New Data'
      && this.index.title !== this.index.draft.title
  }

  async saveDraft(notify = false) {
    const id = this.index.draftId

    try {
      const responsePromise = gateway.post(`cms/engage/indices/drafts/${id}/revisions`, this.index.draft)
      await responsePromise

      if (notify) {
        this.$notify(successNotification(`Your recent changes for ${this.index.title} were saved as draft.`))
      }
    } catch (error) {
      this.$notify(warningNotification('Insufficient permissions.'))
    }
  }

  onSaveDraft(data) {
    this.index.draft = {
      ...this.index.draft,
      ...data
    }
    this.saveDraft(true)
  }

  onUpdate(data) {
    this.index.draft = {
      ...this.index.draft,
      ...data
    }

    this.saveDraft()
  }

  async onPublish(data) {
    this.index.draft = {
      ...this.index.draft,
      ...data
    }
    await this.saveDraft()
    if (!this.hasDifferentTitle) {
      await this.confirmedPublishing()
    } else {
      this.$nextTick(() => this.$modal.show('confirm-publish'))
    }
  }

  async confirmedPublishing() {
    const id = this.index.draftId
    try {
      const response = await gateway.post(`cms/engage/indices/drafts/${id}/publish`, {})

      this.$notify(successNotification(`Your changes for ${this.index.title} have been published.`))
      this.$router.push('/indices')
    } catch (error) {
      this.$notify(warningNotification(error.response?.data?.error || 'Insufficient permissions.'))
    }
  }
}
</script>
